import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-add-animal-death',
  templateUrl: './add-animal-death.component.html',
  styleUrls: ['./add-animal-death.component.css']
})
export class AddAnimalDeathComponent implements OnInit {

  animal_death: FormGroup;

  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";
  addDeathFormValue: any;
  addUrl: any;
  route: any;
  getlistApi: any;
  statusupdate: any;
  getSamplesListData: any
  fragment: any;
  loginresponse: any;
  cby_mby: any;

  date_of_death: any;
  causes_of_death: any;

  error_flag: boolean = false;

  constructor(private router: Router, private commonService: CommonService, private formbuilder: FormBuilder) {

    this.animal_death = this.formbuilder.group({

      date_of_death: ['', Validators.required],
      causes_of_death: ['', Validators.required]

    })

  }

  ngOnInit(): void {
    var today = new Date().toISOString().split('T')[0];
    document.getElementsByName("deathdate")[0].setAttribute('max', today);
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }
  deletiondateselect(e) {
    console.log(e.target.value)
    if (e.target.value) {
      this.statusupdate = "0";
    }
  }
  async AnimalDeath() {

    if (!this.date_of_death || !this.causes_of_death) {
      if (!this.date_of_death) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.causes_of_death) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      return;
    }

    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');
    this.addDeathFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "age_group": ageid,
      "cause_of_death": $("#dathcause").val(),
      "date_of_death": $("#deathdate").val(),
      "cby": this.cby_mby,
      "status": this.statusupdate,
      "is_active": 1
    };
    console.log('causes_of_death', this.addDeathFormValue)
    this.addUrl = "/animal_management/death";
    (await this.commonService.postApi(this.addUrl, this.addDeathFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'sample' }]);

      },
      500
    );
    //}

  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }

}
